import { render, staticRenderFns } from "./ProgramadorProgramador.vue?vue&type=template&id=3bcc01fa&"
import script from "./ProgramadorProgramador.vue?vue&type=script&lang=js&"
export * from "./ProgramadorProgramador.vue?vue&type=script&lang=js&"
import style0 from "./ProgramadorProgramador.vue?vue&type=style&index=0&id=3bcc01fa&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports